import { createTheme } from '@mui/material/styles';
import { colors, typography } from './designTokens';

// יצירת MUI Theme שמשתמש ב-Design Tokens הקיימים
export const muiTheme = createTheme({
  direction: 'rtl', // RTL support
  palette: {
    primary: {
      main: colors.orange, // #F5B658 - הצבע הכתום-זהב
      contrastText: colors.textPrimary, // לבן לטקסט
    },
    secondary: {
      main: colors.orangeGold, // זהב
      contrastText: colors.textPrimary,
    },
    background: {
      default: colors.background, // שחור
      paper: colors.backgroundMuted, // אפור כהה
    },
    text: {
      primary: colors.textPrimary, // לבן
      secondary: colors.textSecondary, // אפור בהיר
    },
    error: {
      main: '#f44336', // אדום לשגיאות
    },
    success: {
      main: '#4caf50', // ירוק להצלחה
    },
  },
  typography: {
    fontFamily: typography.body.fontFamily, // Assistant לטקסט רגיל
    h1: {
      fontFamily: typography.heading.fontFamily, // Ploni לכותרות
      fontWeight: 900,
      letterSpacing: typography.heading.letterSpacing,
      lineHeight: typography.heading.lineHeight,
    },
    h2: {
      fontFamily: typography.heading.fontFamily, // Ploni לכותרות
      fontWeight: 900,
      letterSpacing: typography.heading.letterSpacing,
      lineHeight: typography.heading.lineHeight,
    },
    h3: {
      fontFamily: typography.heading.fontFamily, // Ploni לכותרות
      fontWeight: 700,
      letterSpacing: typography.heading.letterSpacing,
      lineHeight: typography.heading.lineHeight,
    },
    body1: {
      fontFamily: typography.body.fontFamily, // Assistant לטקסט רגיל
      letterSpacing: typography.body.letterSpacing,
      lineHeight: typography.body.lineHeight,
    },
    body2: {
      fontFamily: typography.body.fontFamily, // Rubik לטקסט רגיל - כמו של ירושלים ובני ברק
      letterSpacing: typography.body.letterSpacing,
      lineHeight: typography.body.lineHeight,
    },
  },
  shape: {
    borderRadius: 24, // 24px - matches borderRadius.soft
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#000000 !important', // שחור תמיד
            color: colors.orangeGold, // זהב לטקסט
            '&.Mui-focused': {
              backgroundColor: '#000000 !important', // שחור גם ב-focus
            },
            '&.Mui-filled': {
              backgroundColor: '#000000 !important', // שחור גם כשמלא
            },
            '&:hover': {
              backgroundColor: '#000000 !important', // שחור גם ב-hover
            },
            '& input': {
              backgroundColor: 'transparent !important', // רקע שקוף ל-input
            },
            '& textarea': {
              backgroundColor: 'transparent !important', // רקע שקוף ל-textarea
            },
            '& fieldset': {
              borderColor: colors.orangeGold, // זהב לבורדר
              borderWidth: '2px',
            },
            '&:hover fieldset': {
              borderColor: colors.orange, // כתום בהיר יותר ב-hover
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.orange, // כתום ב-focus
            },
          },
          '& .MuiInputLabel-root': {
            color: colors.orangeGold, // זהב ל-label
            '&.Mui-focused': {
              color: colors.orange, // כתום ב-focus
            },
          },
          '& .MuiInputBase-input': {
            textAlign: 'right', // RTL
            '&::placeholder': {
              color: colors.orangeGold,
              opacity: 1,
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 80, // 80px - matches borderRadius.pill
          textTransform: 'none', // לא להפוך לאותיות גדולות
          fontWeight: 400,
          letterSpacing: typography.body.letterSpacing,
          padding: '8px 24px',
        },
        contained: {
          backgroundColor: colors.orange,
          color: colors.textPrimary,
          '&:hover': {
            backgroundColor: colors.orangeGold,
          },
        },
      },
    },
  },
});

